import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { Paper } from 'shared/ui/paper'
import { SelectWithLabel } from 'shared/ui/select-label'

import { InsuranceTripPurpose } from '../../../../model/types'

import s from './styles.module.scss'

interface PurposeCardProps {
  purposes: InsuranceTripPurpose[]
  purpose: InsuranceTripPurpose | null
  onChange: (purpose: InsuranceTripPurpose) => void
}

export const PurposeCard: FC<PurposeCardProps> = ({
  purposes,
  purpose,
  onChange,
}) => {
  const { t, i18n } = useTranslation()
  const getPurposeName = (item: InsuranceTripPurpose) => {
    if (i18n.language === 'ky') return item.nameKg || item.nameRu
    if (i18n.language === 'en') return item.nameEn || item.nameRu
    return item.nameRu
  }

  return (
    <Paper
      className={s.card}
      padding={[20, 16]}
      radius="20px"
    >
      <h2 className={clsx(s.title, 'bold-17')}>
        {t('insurance.vzr.purpose.label')}
      </h2>
      <SelectWithLabel
        key={`${purposes.length}-${purpose?.id || ''}`}
        label={
          purpose
            ? t('insurance.vzr.purpose.label')
            : t('insurance.vzr.purpose.placeholder')
        }
        title={t('insurance.vzr.purpose.label')}
        value={purpose?.id}
        options={purposes.map((item) => ({
          value: item.id,
          name: getPurposeName(item),
        }))}
        onChange={({ value }) => {
          const selectedPurpose = purposes.find(({ id }) => id === value)
          if (selectedPurpose) onChange(selectedPurpose)
        }}
      />
    </Paper>
  )
}
